import { useState } from 'react';
import { FormUpload } from '../../components';
import { HugeiconsIcon } from '@hugeicons/react';
import { FileAddIcon } from '@hugeicons/core-free-icons';

function OtherDocsUpload({ setValue }) {

    const [counter, setCounter] = useState(0);
    const [files, setFiles] = useState([]);

    const handleNewFile = () => {
        const next = counter + 1;
        setCounter(next);
        setFiles(prev => [...prev, { id: `otherDoc-${next}`, name: `otherDoc-${next}` }]);
    };

    const handleFileUpload = (file) => {
        setValue(prev => [...prev, file]);
    };

    return (
        <div className="col-span-full space-y-3">
            {files.map((file, index) => (
                <FormUpload
                    key={file.id}
                    label={`Other Document ${index + 1}`}
                    name={file.name}
                    id={file.id}
                    setValue={handleFileUpload}
                />
            ))}

            <button
                type="button"
                onClick={handleNewFile}
                className="flex items-center gap-2 w-full rounded-xl border-2 border-dashed border-gray-200 dark:border-gray-600 px-4 py-3.5 text-sm font-medium text-gray-500 dark:text-gray-400 hover:border-[#1e3a6e]/30 dark:hover:border-blue-500/40 hover:text-[#1e3a6e] dark:hover:text-blue-400 hover:bg-blue-50/20 dark:hover:bg-blue-500/10 transition-colors"
            >
                <HugeiconsIcon icon={FileAddIcon} size={15} />
                Add another file
            </button>
        </div>
    );
}

export default OtherDocsUpload;
